import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { take } from 'rxjs';
import { AppService } from '../../app.service';
import { Address } from '../../models/address';
import { County } from '../../models/county';
import { State } from '../../models/state';

@Component({ standalone: false,
  selector: 'edit-address-dialog',
  templateUrl: 'edit-address-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['edit-address-dialog.component.scss']
})
export class EditAddressDialogComponent {
  title: string= "Additional Address";
  confirmButtonText = "OK";
  cancelButtonText = "Cancel";

  public states : State[] = [];
  public counties : County[] = [];
  public selectedState?:State;
  public selectedCounty?:County;

  public currentAddress!:Address;
  public addressForm:FormGroup;

  constructor(public appService:AppService, @Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<EditAddressDialogComponent>) {
    this.addressForm = new FormGroup({
      state: new FormControl<State | undefined>(undefined),
      county: new FormControl<County | undefined>(undefined),
      city: new FormControl<string | undefined>(undefined),
      zipCode: new FormControl<string | undefined>(undefined),
      streetAddress1: new FormControl<string | undefined>(undefined),
      streetAddress2: new FormControl<string | undefined>(undefined)
    });
    this.appService.states.pipe(take(1)).subscribe((r: any)=>{this.states=r;});
    if(data){
        if (data.address) {
          this.currentAddress=data.address;
        }
    }
  }

  ngOnInit(){

    if(this.currentAddress) this.populateForm(this.currentAddress);
  }

  private populateForm(address:Address){
    this.addressForm.get('streetAddress1')!.setValue(address.streetAddress1);
    this.addressForm.get('streetAddress2')!.setValue(address.streetAddress2);
    this.addressForm.get('city')!.setValue(address.city);
    if(address.state){
      this.appService.getStateByCode(address.state).pipe(take(1)).subscribe(s=>{
        this.addressForm.get('state')!.setValue(s);
        this.selectedState=s;
        if(s){
          this.appService.getCounties(s.id).pipe(take(1)).subscribe(ca=>{
            this.counties=ca;
            if(address.county){
              this.appService.getCountyByName(s.id, address.county).pipe(take(1)).subscribe(c=>{
                this.addressForm.get('county')!.setValue(c);
                this.selectedCounty=c;
              });
            }
          });
       }
      });
    }
    this.addressForm.get('zipCode')!.setValue(address.zipCode);
  }

  public onSelectState(){
    this.selectedState= this.addressForm.get('state')!.value;
    if(this.selectedState) this.appService.getCounties(this.selectedState.id).pipe(take(1)).subscribe((r: any)=>{this.counties=r;});
    else this.counties=[];
  }

  public onSelectCounty(){
      this.selectedCounty=this.addressForm.get('county')!.value;
  }

  get addressData(){
    if(!this.currentAddress){
      this.currentAddress = new Address();
    }
    this.currentAddress.streetAddress1=this.addressForm.get('streetAddress1')!.value;
    this.currentAddress.streetAddress2=this.addressForm.get('streetAddress2')!.value;
    this.currentAddress.city=this.addressForm.get('city')!.value;
    this.currentAddress.state=this.addressForm.get('state')!.value.stateCode;
    this.currentAddress.zipCode=this.addressForm.get('zipCode')!.value;
    this.currentAddress.county=this.addressForm.get('county')!.value?.name;
    this.currentAddress.countyId=this.addressForm.get('county')!.value?.id;
    this.currentAddress.country='US';
    return this.currentAddress;
  }

  onConfirmClick(): void {
    this.dialogRef.close(this.addressData);
  }

  onCancelClick(): void {
    this.dialogRef.close(undefined);
  }

}